import pckg from '../../package.json';

// auto-detect correct environment
const domainArr = document.location.hostname.split('.');
let ENVIRONMENT = 'production';
if (domainArr[0] === 'www') {
  ENVIRONMENT = 'production';
} else if (domainArr[0] === 'localhost' || domainArr[0] === '192') {
  ENVIRONMENT = 'local';
} else if (domainArr[0] === 'dev') {
  ENVIRONMENT = 'dev';
} else if (domainArr[0] === 'staging') {
  ENVIRONMENT = 'staging';
} else if (domainArr[0] === 'local') {
  ENVIRONMENT = 'docker-local';
}

const config = {
  ENVIRONMENT: process.env.SITE_ENV || ENVIRONMENT, // local, docker-local, dev, staging, production
  DOMAIN: '***NEED-TO-BE-CHANGED***',
  TITLE: '***NEED-TO-BE-CHANGED***',
  VERSION: pckg.version,
  SESSION_COOKIE_NAME: 'session_token',
  SESSION_COOKIE_DOMAIN: '***NEED-TO-BE-CHANGED***',
  SESSION_INIT_COOKIE_NAME: 'session_init',
  SESSION_COOKIE_SECURE: true,
  NICHE: '***NEED-TO-BE-CHANGED***',
  PROJECT: '***NEED-TO-BE-CHANGED***',
  NICHE_SINGULAR: '***NEED-TO-BE-CHANGED***',
  NICHE_PLURAL: '***NEED-TO-BE-CHANGED***',
  NBS_API_VERSION: '227',
  LANGUAGE: 'en',
  GENDER_ONE: 1,
  GENDER_TWO: 2,
  FB_TRACKING_PIXEL_ID: [],
  TOAST_TIMEOUT: 3000,
  AGE_SLIDER_LOWER: 18,
  AGE_SLIDER_UPPER: 99,
  EMAIL_REGEX:
    /^(([^<>()[\]\\.,;:\s@"']+(\.[^<>()[\]\\.,;:\s@"']+)*)|(".+"))@(?!-)((?!_)[a-zA-Z0-9-]+(?<!-)\.)+[a-zA-Z]{2,}$/,
  TEXTAREA_REGEX: /^\s*$/,
  QUICK_MATCH_RESULT_TO_GET: 20,
  CENTER_WRAPPER_CONTENT_WIDTH: '40vw',
  CANCEL_VIP_THRESHOLD_DAYS: 31,
  IS_LANDSCAPE: false,
  ROCKET_GATE: 'ROCKET_GATE',
  PAYPAL: 'PAYPAL',
  COMPANY_NAME: 'nbsocial.com',
  COMPANY_PHONE: '800-686-2192',
  GOOGLE_ID: '***NEED-TO-BE-CHANGED***',
  APP_INIT_MISSING: [
    'update_dob',
    'update_sex',
    'update_username',
    'update_password',
    'add_location',
    'add_email',
    'need_explicit_opt_in',
    'update_first_name',
    'update_profile_ext_height',
    'update_profile_ext_ethnicity',
    'update_profile_ext_body_type',
    'update_pref_ages',
    'update_pref_radius',
    'update_tag_line',
    'upload_photo',
    'show_initial_offer',
    // 'show_initial_upgrade',
    'show_postponed_upgrade',
    'update_declined_username',
    'update_declined_tagline',
    'update_declined_photo',
    'show_special_offer_2x',
  ],
  APP_INIT_ONBOARDING: [
    'update_dob',
    'update_sex',
    'update_username',
    'update_password',
    'add_location',
    'add_email',
    'need_explicit_opt_in',
    'update_first_name',
    'update_profile_ext_height',
    'update_profile_ext_ethnicity',
    'update_profile_ext_body_type',
    'update_pref_ages',
    'update_pref_radius',
    'update_tag_line',
    'upload_photo',
    'show_initial_offer',
    'show_nearby_connect_dialog',
    'upgrade_modal',
    'success_upgrade',
  ],
  LOGOUT_ADS_NO: 4,
  ENABLE_SERVICE_WORKER: true,
  PREF_RADIUS: 250, // in miles - 402 km
  SUPPORTED_LANGUAGES: ['da', 'de', 'en', 'es', 'fi', 'fr', 'hu', 'sv'],
  COOKIE_CONSENT_NAME: 'cookie-consent',
  COOKIE_GOOGLTE_TAG_MANAGER: 'googleTagManagerConsent',
  SPLITIO_USER_KEY: 'f5663ab0-7cb0-11ee-8e3d-32ad8a174383',
  SPLITIO_AUTH_KEY_DEV: 'lpp0dfjcjjckpf917f67jur13g596fq28dk8',
  SPLITIO_AUTH_KEY_PROD: 't0957najclhq073fn15i4rvma8fqan41p8ee',
  FEATURE_FLAGS: ['isSentryEnabledForWeb', 'isValentineEnabledForWeb'],
};

const makeConfig = (newConfig) => {
  const resConfig = Object.assign({}, config, newConfig);

  // overrides
  if (resConfig.ENVIRONMENT === 'production') {
    resConfig.SESSION_COOKIE_DOMAIN = `www.${resConfig.DOMAIN}`;
    resConfig.NBS_API_URL =
      'https://http.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION +
      '/';
    resConfig.NBS_WS_API_URL =
      'wss://ws.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION;
    resConfig.DOMAIN = `https://www.${resConfig.DOMAIN}`;
    resConfig.THREEDS_API_DOMAIN = 'https://centinelapi.cardinalcommerce.com';
    resConfig.THREEDS_API_DOMAIN_NEW = 'https://client.cardinaltrusted.com';
  } else if (resConfig.ENVIRONMENT === 'staging') {
    resConfig.SESSION_COOKIE_DOMAIN = `staging.${resConfig.DOMAIN}`;
    resConfig.NBS_API_URL =
      'https://http.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION +
      '/';
    resConfig.NBS_WS_API_URL =
      'wss://ws.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION;
    resConfig.DOMAIN = `https://staging.${resConfig.DOMAIN}`;
    resConfig.THREEDS_API_DOMAIN =
      'https://centinelapistag.cardinalcommerce.com';
    resConfig.THREEDS_API_DOMAIN_NEW = 'https://cas.client.cardinaltrusted.com';
  } else if (resConfig.ENVIRONMENT === 'dev') {
    resConfig.SESSION_COOKIE_DOMAIN = `dev.${resConfig.DOMAIN}`;
    resConfig.NBS_API_URL =
      'https://httpdev.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION +
      '/';
    resConfig.NBS_WS_API_URL =
      'wss://wsdev.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION;
    resConfig.EMAIL_REGEX =
      /^([a-zA-Z0-9+]+([.+\-_][a-zA-Z0-9]+)*)@(?!-)((?!_)[a-zA-Z0-9-]+(?<!-)\.)+[a-zA-Z]{2,}$/;
    resConfig.DOMAIN = `https://dev.${resConfig.DOMAIN}`;
    resConfig.THREEDS_API_DOMAIN =
      'https://centinelapistag.cardinalcommerce.com';
    resConfig.THREEDS_API_DOMAIN_NEW = 'https://cas.client.cardinaltrusted.com';
  } else if (resConfig.ENVIRONMENT === 'local') {
    resConfig.SESSION_COOKIE_DOMAIN = '';
    resConfig.SESSION_COOKIE_SECURE = false;
    resConfig.NBS_API_URL =
      'https://httpdev.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION +
      '/';
    resConfig.NBS_WS_API_URL =
      'wss://wsdev.nearbyapi.com/' +
      resConfig.PROJECT +
      '/v' +
      resConfig.NBS_API_VERSION;
    resConfig.EMAIL_REGEX =
      /^([a-zA-Z0-9+]+([.+\-_][a-zA-Z0-9]+)*)@(?!-)((?!_)[a-zA-Z0-9-]+(?<!-)\.)+[a-zA-Z]{2,}$/;
    resConfig.DOMAIN = 'http://localhost:3000';
    resConfig.THREEDS_API_DOMAIN =
      'https://centinelapistag.cardinalcommerce.com';
    resConfig.THREEDS_API_DOMAIN_NEW = 'https://cas.client.cardinaltrusted.com';
  } else if (resConfig.ENVIRONMENT === 'docker-local') {
    resConfig.SESSION_COOKIE_DOMAIN = `local.${resConfig.DOMAIN}`;
    resConfig.NBS_API_URL = `https://local.${resConfig.DOMAIN}:8081/${resConfig.PROJECT}/v${resConfig.NBS_API_VERSION}/`;
    resConfig.NBS_WS_API_URL = `wss://local.${resConfig.DOMAIN}:8002/${resConfig.PROJECT}/v${resConfig.NBS_API_VERSION}`;
    resConfig.EMAIL_REGEX =
      /^([a-zA-Z0-9+]+([.+\-_][a-zA-Z0-9]+)*)@(?!-)((?!_)[a-zA-Z0-9-]+(?<!-)\.)+[a-zA-Z]{2,}$/;
    resConfig.DOMAIN = `https://local.${resConfig.DOMAIN}`;
    resConfig.THREEDS_API_DOMAIN =
      'https://centinelapistag.cardinalcommerce.com';
    resConfig.THREEDS_API_DOMAIN_NEW = 'https://cas.client.cardinaltrusted.com';
  }

  resConfig.NBS_API_URL_DOWNLOAD_USER_DATA =
    resConfig.NBS_API_URL + 'downloadUserData';

  return resConfig;
};

export { makeConfig };
